import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Gamepad2 } from 'lucide-react';
import { GameArtwork } from '../originals/GameArtwork';

export const VipOriginalsEndCard = () => <article className="originals-game is-static" data-testid="vip-originals-end-card">
  <Link to="/originals" className="originals-game-link vip-originals-end-link" aria-label="View all Originals" data-testid="vip-originals-view-all">
    <div className="originals-game-cover"><div className="vip-originals-end-art" aria-hidden="true" data-testid="vip-originals-end-art"><GameArtwork game="keno" /></div>
    <span className="vip-originals-end-action" data-testid="vip-originals-end-action"><Gamepad2 size={26} aria-hidden="true" /><strong>View all Originals</strong><ArrowUpRight size={20} aria-hidden="true" /></span></div>
    <div className="originals-game-meta"><span data-testid="vip-originals-end-label">Explore the collection</span><ArrowUpRight size={16} aria-hidden="true" /></div>
  </Link>
</article>;